'use strict';

import React from 'react';
import CustomerInfo from "./customer-info";
import BasicMetrics from "./basic-metrics";
import MetricsByFilter from "./metrics-by-filter";
import {DashboardFilterProvider} from './state';
import Filter from "./filter";

function Dashboard3D() {
	return (
		<div id="cm-dashboard">
			<h1 className="page-header">Usage dashboard</h1>
			<CustomerInfo/>
			<DashboardFilterProvider>
				<Filter/>
				<BasicMetrics/>
				<MetricsByFilter/>
			</DashboardFilterProvider>
		</div>
	);
}

export default Dashboard3D;